import NotificationServiceModel from '@/models/NotificationServiceModel';
import doc                      from '@widesk-core/decorators/doc';

type SubscriptionStatusReference = 'enabled' | 'disabled';

@doc.path('/stonecode_notification_subscription_statuses/{?id}')
export default class SubscriptionStatusModel extends NotificationServiceModel {

	@doc.string declare reference: SubscriptionStatusReference;
}